<template>
  <div>
    <v-card flat> <ai-mail /> </v-card>
  </div>
</template>

<script>
import aiMail from "@/components/ai/aiMail.vue"

export default {
  components: {
    aiMail,
  },
  data() {
    return {}
  },
  async created() {},
  methods: {},
}
</script>
